<!--
 * @Description:
 * @Author: wjx
 * @Github:
 * @LastEditors: wjx
 * @Date: 2019-04-28 13:17:06
 * @LastEditTime: 2019-04-28 19:06:24
 -->
<template>
  <div class="table-box">
    <!--查询-->
    <div class="search-box">
      <div class="search-left">
        <div>
          <span>状态：</span>
                        <el-select v-model="searchQuery.status" clearable placeholder="请选择">

            <el-option
              label="待审核"
              :value="1">
            </el-option>
            <el-option
              label="审核通过"
              :value="2">
            </el-option>
            <el-option
              label="审核未通过"
              :value="3">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="search-right">
        <el-button type="primary" @click="searchEvent">搜索</el-button>
                <el-button type="primary" @click="receiveAll">全部通过</el-button>

        <!-- <el-button type="primary" @click="searchEvent">搜索</el-button> -->
      </div>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border=""
        style="width: 100%"
        :stripe="true"
        :highlight-current-row="false"
      >
        <el-table-column type="index" label="序号" align="center" width="80"></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="enterpriseName"
          label="企业"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="projectName"
          label="项目名称"
        ></el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" label="创建时间">
          <template slot-scope="scope">{{scope.row.createDt}}</template>
        </el-table-column>
        <el-table-column label="操作" width="250" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="goDistDetail(scope.row)"
              :disabled="scope.row.projectStatus<=0"
            >任务下发</el-button>
            <el-button
              type="text"
              size="small"
              @click="goAccepttDetail(scope.row)"
              :disabled="scope.row.projectStatus<=0"
            >任务接收</el-button>
            <el-button
              type="text"
              size="small"
              @click="goDetail(scope.row)"
              :disabled="scope.row.projectStatus!=0"
            >编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNum"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, jumper"
        style="padding:15px"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import {
  zsBingli,
  search,
  receive
} from "@/api/ajax";
import {
  pageInation
} from "@/Mixin/listMixin";
import {
  initSearch
} from "@/Mixin/initSearch";
import {
  makeSure
} from "@/Mixin/makeSure";
import dicSelect from "@/components/Common/dicSelect.vue";
export default {
  mixins: [pageInation, makeSure],
  data () {
    return {
      ruleForm: {},
      getList: zsBingli.projectList, // 获取列表的AJAX
      searchAjax: search.yshEnterpriseList,
      searchQuery: {
        projectName: "",
        type: 1 //写死的不要动
      },
      prop: {
        label: "enterpriseName",
        code: "enterpriseId"
      }
    };
  },
  components: {
    dicSelect
  },
  computed: {},
  methods: {
    receiveAll(){
      receive.receiveTaskRecord({
        statementId:this.$route.query.statementId,
        isAll:1,
        auditGongyeStatus:2
      }).then(res=>{
        

        this.$message.success(res.data)
         this.searchEvent()
      })
    },
    saveEnterpriseId (val) {
      this.searchQuery.enterpriseId = val.enterpriseId;
    },
    goDistDetail (row) { //分配任务
      this.$router.push({
        name: "caseTaskList",
        query: {
          id: row.id
        }
      });
    },
    goAccepttDetail (row) { //任务接收
      this.$router.push({
        name: "caseAcceptList",
        query: {
          id: row.id
        }
      });
    },
    goDetail (row) {
      this.$router.push({
        name: "caseProjectAddEdit",
        query: {
          id: row.id
        }
      });
    },
  },
  filters: {
    transAuditStatus (val) {
      if (val == 1) {
        return "已启用";
      } else {
        return "已停用";
      }
    }
  },
  created () { }
};

</script>
